import { StripePaymentForm } from '@app/components';
import Logo from '@app/assets/horizontal-logo.svg?react';
import { useNavigate } from 'react-router-dom';
import { useSubscriptionRenewalPage } from './SubscriptionRenewal.hooks';

export const SubscriptionRenewal = () => {
  const navigate = useNavigate();
  const { planDetails, clientSecret, handleStripeSuccess, isProcessing, isLoading } = useSubscriptionRenewalPage();

  if (isLoading || !planDetails) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-baseBlue mx-auto mb-4"></div>
          <p className="text-base-coolGray">Loading renewal form...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center flex-col min-h-screen py-6 bg-gray-50">
      <Logo width={139} height={110} className="mb-auto" />

      <div className="bg-white rounded-lg p-8 max-w-lg w-full mx-auto">
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Renew Subscription</h2>
          <p className="text-sm text-brand-baseBlue font-medium">{planDetails.name}</p>
          <p className="text-3xl font-bold text-gray-900">
            {planDetails.price} <span className="text-gray-500 text-lg">/monthly</span>
          </p>
        </div>

        {clientSecret && (
          <StripePaymentForm
            clientSecret={clientSecret}
            onSuccess={handleStripeSuccess}
            onCancel={() => navigate('/settings?tab=plan')}
            submitLabel="Renew Subscription"
            isLoading={isProcessing}
          />
        )}
      </div>

      <p className="mt-auto text-base-coolGray">
        Need help?{' '}
        <a
          href="mailto:contact@echoratings.com"
          className="text-brand-baseBlue hover:underline"
        >
          Contact Support
        </a>
      </p>
    </div>
  );
};
